export default __webpack_public_path__ + "40902bc97113e24ab55069767bec1c57.png";